export enum IAvatarSizeTheme {
	DEFAULT = 'DEFAULT',
	LARGE = 'LARGE',
}

export enum IAvatarBorderTheme {
	ROUNDED = 'ROUNDED',
}
